/** Maps lead `source` values from forms to GTM / ads-friendly conversion labels. */
export const LEAD_CONVERSION_LABELS: Record<string, string> = {
  "growth-audit": "growth_gap_audit",
  contact: "contact",
  lead: "lead",
};

export function conversionLabelForSource(source: string) {
  return LEAD_CONVERSION_LABELS[source] ?? source.replace(/[^a-z0-9]+/gi, "_").toLowerCase();
}

export type LeadConversionPayload = {
  event: "dbm_lead_submit";
  lead_source: string;
  lead_reference: string;
  conversion_type: string;
};

export function buildLeadConversionPayload(source: string, reference: string): LeadConversionPayload {
  return {
    event: "dbm_lead_submit",
    lead_source: source,
    lead_reference: reference,
    conversion_type: conversionLabelForSource(source),
  };
}
